function loadKampusMengajar(view) {
    return () => import( /* webpackChunkName: "kampusMengajar-[request]" */ `../../views/KampusMerdeka/KampusMengajar/${view}.vue`)
}
function loadBimbinganKampusMengajar(view) {
    return () => import( /* webpackChunkName: "bimbinganKampusMengajar-[request]" */ `../../views/KampusMerdeka/BimbinganKampusMengajar/${view}.vue`)
}

const kampusMengajarRoute = [
    {
        path: '/kampus-merdeka/kampus-mengajar',
        name: 'KampusMengajarMahasiswaView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKampusMengajar('MahasiswaView')
    },
    {
        path: '/kampus-merdeka/kampus-mengajar-verify',
        name: 'KampusMengajarVerifyView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKampusMengajar('KampusMengajarVerifyView')
    },
    {
        path: '/kampus-mengajar-logbook/:id',
        name: 'LogbookKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKampusMengajar('LogbookKampusMengajar')
    },
    {
        path: '/kampus-mengajar-dosbim/:detail_id',
        name: 'DosbimKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKampusMengajar('KampusMengajarAdvisor')
    },
    {
        path: '/kampus-mengajar-rubric',
        name: 'RubricKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKampusMengajar('RubricCategory')
    },
    {
        path: '/kampus-mengajar-rubric/:category_id',
        name: 'RubricFieldKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKampusMengajar('RubricField')
    },
    {
        path: '/kampus-mengajar-exam/:id',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKampusMengajar('MainViewExam'),
        children: [
            {
                path: '',
                name: 'Ujian Kampus Mengajar',
                component: loadKampusMengajar('ExamDetail')
            },
            {
                path: 'sekolah',
                name: 'Penilaian Sekolah',
                component: loadKampusMengajar('InstitusiRubric')
            },
            {
                path: 'lecture',
                name: 'Penilaian Dosen Pembimbing Kampus Mengajar',
                component: loadKampusMengajar('LectureRubric')
            },
            {
                path: 'result',
                name: 'Nilai Kampus Mengajar',
                component: loadKampusMengajar('KampusMengajarResult')
            }
        ]
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/kampus-mengajar/:student_id',
        name: 'MyStudentGuidancesKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKampusMengajar('ListBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/kampus-mengajar',
        name: 'MyGuidanceStudentsKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKampusMengajar('ListMahasiswaBimbingan')
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/kampus-mengajar/:student_id/:guidance_id',
        name: 'ResponseMyStudentGuidanceKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKampusMengajar('ResponseBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/mahasiswa/bimbingan/kampus-mengajar/:guidance_id',
        name: 'ResponseGuidanceKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKampusMengajar('ResponseBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/mahasiswa/bimbingan/kampus-mengajar',
        name: 'ListBimbinganKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKampusMengajar('ListBimbingan')
    },
    {
        path: '/kampus-merdeka/form/bimbingan/kampus-mengajar',
        name: 'FormBimbinganKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKampusMengajar('FormBimbingan')
    },
    {
        path: '/kampus-mengajar-exam',
        name: 'KampusMengajarVerifyExam',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadKampusMengajar('VerifyExam')
    },
    {
        path: '/konversi-kampus-mengajar',
        name: 'StudentConvertionViewKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi']
        },
        component: loadKampusMengajar('StudentConvertionView')
    },
    {
        path: '/konversi-kampus-mengajar/mata-kuliah/:id',
        name: 'ConvertionViewKampusMengajar',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKampusMengajar('ConvertionView')
    },
    {
        path: '/konversi-kampus-mengajar/mata-kuliah/:id/TU',
        name: 'ConvertionViewKampusMengajarAdmin',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['administrator', 'mahasiswa']
        },
        component: loadKampusMengajar('ConvertionViewAdmin')
    },
]

export default kampusMengajarRoute